import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { LoginResponseDataSchema } from "schema"
import { z } from "zod"

type CompleteSignupData = {
  setupToken: string
  companyName: string
  name: string
  password: string
  confirmPassword: string
}

export const useCompleteSignupByWebsiteMutation = () => {
  return useMutation({
    mutationFn: async (data: CompleteSignupData) => {
      const { data: response } = await axios.post("/auth/complete-signup-website", data)
      return response.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
